import { Api } from '@shared/api/Api';
import { ISettingsPositionsGetQuery } from '../Positions';
import { ListResult } from '@shared/api/interfaces';

export class RebalancingJob {
    private static _basePath = '/RebalancingJob';

    public static getMethods(parentPath: string) {
        const basePath = `${parentPath}${RebalancingJob._basePath}`;
        return {
            async userRebalancing(AccountId: number) {
                const path = `/userRebalancing?userId=${AccountId}`;
                return await Api.get<any>({
                    path: `${basePath}${path}`,
                });
            },

            async bulkUserRebalancing(AccountId: number) {
                const path = `/bulkUserRebalancing?userId=${AccountId}`;
                return await Api.get<any>({
                    path: `${basePath}${path}`,
                });
            },

            async getTradeOrderListing(query: ISettingsPositionsGetQuery) {
                const path = `/getRebalancingJobItems`;
                return await Api.get<ListResult<any>>({
                    path: `${basePath}${path}`, // need to verify it
                    query,
                });
            },
        };
    }
}
